module.exports = __webpack_public_path__ + "images/pro/payment-qrcode_v2-dcf9f14603ed2cf7383e59341e6a28d9.png";